/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface V1VsphereVirtualDiskVolumeSource
 */
export interface V1VsphereVirtualDiskVolumeSource {
    /**
     * fsType is filesystem type to mount.
     * Must be a filesystem type supported by the host operating system.
     * Ex. "ext4", "xfs", "ntfs". Implicitly inferred to be "ext4" if unspecified.
     * +optional
     * @type {string}
     * @memberof V1VsphereVirtualDiskVolumeSource
     */
    fsType?: string;
    /**
     * storagePolicyID is the storage Policy Based Management (SPBM) profile ID associated with the StoragePolicyName.
     * +optional
     * @type {string}
     * @memberof V1VsphereVirtualDiskVolumeSource
     */
    storagePolicyID?: string;
    /**
     * storagePolicyName is the storage Policy Based Management (SPBM) profile name.
     * +optional
     * @type {string}
     * @memberof V1VsphereVirtualDiskVolumeSource
     */
    storagePolicyName?: string;
    /**
     * volumePath is the path that identifies vSphere volume vmdk
     * @type {string}
     * @memberof V1VsphereVirtualDiskVolumeSource
     */
    volumePath?: string;
}

export function V1VsphereVirtualDiskVolumeSourceFromJSON(json: any): V1VsphereVirtualDiskVolumeSource {
    return V1VsphereVirtualDiskVolumeSourceFromJSONTyped(json, false);
}

export function V1VsphereVirtualDiskVolumeSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1VsphereVirtualDiskVolumeSource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fsType': !exists(json, 'fsType') ? undefined : json['fsType'],
        'storagePolicyID': !exists(json, 'storagePolicyID') ? undefined : json['storagePolicyID'],
        'storagePolicyName': !exists(json, 'storagePolicyName') ? undefined : json['storagePolicyName'],
        'volumePath': !exists(json, 'volumePath') ? undefined : json['volumePath'],
    };
}

export function V1VsphereVirtualDiskVolumeSourceToJSON(value?: V1VsphereVirtualDiskVolumeSource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fsType': value.fsType,
        'storagePolicyID': value.storagePolicyID,
        'storagePolicyName': value.storagePolicyName,
        'volumePath': value.volumePath,
    };
}

